import { render } from "./Loader.vue?vue&type=template&id=51528916"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=51528916&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__